import React from "react";
import { useEditorState } from "@tiptap/react";
import "./EditorToolbar.css";

// Values are full CSS strings — Tiptap v3 FontSize stores them verbatim
const FONT_SIZES = [
  { label: "S", value: "10pt", title: "Small (10pt)" },
  { label: "M", value: "12pt", title: "Normal (12pt)" },
  { label: "L", value: "16pt", title: "Large (16pt)" },
];

const EditorToolbar = ({ editor }) => {
  // useEditorState subscribes to every transaction (cursor move, selection change,
  // content edit) and re-renders the toolbar with the correct active state.
  const state = useEditorState({
    editor,
    selector: (ctx) => {
      const e = ctx.editor;
      const textStyle = e.getAttributes("textStyle");
      return {
        isBold: e.isActive("bold"),
        isItalic: e.isActive("italic"),
        fontSize: textStyle.fontSize || "",
        color: textStyle.color || "#000000",
      };
    },
  });

  if (!editor || !state) return null;

  const { isBold, isItalic, fontSize, color } = state;

  return (
    <div className="rich-toolbar" onMouseDown={(e) => e.preventDefault()}>
      {/* Bold */}
      <button
        type="button"
        className={`rich-toolbar__btn rich-toolbar__btn--bold ${isBold ? "is-active" : ""}`}
        onClick={() => editor.chain().focus().toggleBold().run()}
        title="Bold"
      >
        B
      </button>

      {/* Italic */}
      <button
        type="button"
        className={`rich-toolbar__btn rich-toolbar__btn--italic ${isItalic ? "is-active" : ""}`}
        onClick={() => editor.chain().focus().toggleItalic().run()}
        title="Italic"
      >
        I
      </button>

      <div className="rich-toolbar__separator" />

      {/* Font sizes */}
      {FONT_SIZES.map(({ label, value, title }) => (
        <button
          key={value}
          type="button"
          className={`rich-toolbar__btn rich-toolbar__btn--size ${fontSize === value ? "is-active" : ""}`}
          onClick={() => {
            if (fontSize === value) {
              editor.chain().focus().unsetFontSize().run();
            } else {
              editor.chain().focus().setFontSize(value).run();
            }
          }}
          title={title}
        >
          {label}
        </button>
      ))}

      <div className="rich-toolbar__separator" />

      {/* Color picker — value comes from editor state, not local useState */}
      <div className="rich-toolbar__color-wrapper" title="Text color">
        <div className="rich-toolbar__color-btn">
          <span className="rich-toolbar__color-btn-letter">A</span>
          <span
            className="rich-toolbar__color-btn-swatch"
            style={{ backgroundColor: color }}
          />
        </div>
        <input
          type="color"
          className="rich-toolbar__color-input"
          value={color}
          onChange={(e) => editor.chain().focus().setColor(e.target.value).run()}
          title="Text color"
        />
      </div>
    </div>
  );
};

export default EditorToolbar;
